import React from "react";
import { FlexBox } from "components/flex-box";
import { H1, H5 } from "components/Typography";
import { AiBuilderSearchBar } from "./AiBuilderSearchBar";
import { useIsMobile } from "hooks";

type WorthBannerProps = {
  title?: string;
  cover?: string;
  hasSearch?: boolean;
  subtitle?: string;
  getAiBuildFunc?: any;
};

const WorthBanner: React.FC<WorthBannerProps> = ({
  title,
  cover,
  hasSearch,
  subtitle,
  getAiBuildFunc,
}) => {
  const isMobile = useIsMobile();

  return (
    <FlexBox>
      <div
        style={{
          backgroundImage: `url('${cover}')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
          height: isMobile ? "30vh" : "40vh",
          maxHeight: isMobile ? "30vh" : "40vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <H1
          style={{
            textAlign: "center",
            fontSize: "3em",
            lineHeight: 1,
          }}
          maxWidth={600}
        >
          {title}
        </H1>
        <H5 style={{ textAlign: "center", margin: "0 20px 0 20px" }}>
          {subtitle ? subtitle : ""}
        </H5>
        <div style={{ width: "90%", maxWidth: "500px", marginTop: "15px" }}>
          {hasSearch ? (
            <AiBuilderSearchBar
              disabled={hasSearch}
              onChangeKeyword={getAiBuildFunc}
              value={undefined}
              setSearchValue={() => {}}
              budgetValue={undefined}
            />
          ) : null}
        </div>
      </div>
    </FlexBox>
  );
};

export default WorthBanner;
